<div class="login-tracking-container">
	<div class="login-tracking-header">
		<h2>Recent Login Activity</h2>
		@if (logins.length > 0) {
			<div class="login-count">Showing {{ logins.length }} login{{ logins.length === 1 ? '' : 's' }}</div>
		}
	</div>

	@if (logins.length === 0) {
		<div class="no-logins">
			<p>No login data available</p>
		</div>
	}

	@if (logins.length > 0) {
		<div class="login-list">
			<table>
				<thead>
					<tr>
						<th>Date & Time</th>
						<th>Device</th>
						@if (showUsername) {
							<th>Username</th>
						}
						@if (!showUsername) {
							<th>Client</th>
						}
						<th>IP Address</th>
						<th>Login ID</th>
					</tr>
				</thead>
				<tbody>
					@for (login of logins; track login) {
						<tr>
							<td class="date-column">
								<div class="date-primary">{{ formatDate(login.created) }}</div>
								<div class="date-secondary">{{ formatTime(login.created) }}</div>
							</td>
							<td class="device-column">
								<div class="device-info">
									<span class="device-icon" [ngClass]="getDeviceIconClass(login)"></span>
									<span>{{ getDeviceType(login) }}</span>
								</div>
								@if (getBrowserInfo(login)) {
									<div class="browser-info">
										{{ getBrowserInfo(login) }}
									</div>
								}
							</td>
							@if (showUsername) {
								<td class="username-column">
									{{ login.user_uuid | displayName: 'user' | async }}
								</td>
							}
							@if (!showUsername) {
								<td class="client-column">
									{{ login.client_name || 'Unknown' }}
								</td>
							}
							<td class="ip-column">{{ maskIpAddress(login.ip_address) }}</td>
							<td class="uuid-column">{{ login.uuid.substring(0, 8) }}</td>
						</tr>
					}
				</tbody>
			</table>
		</div>
	}
</div>
